import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import substanceDrugsUsageItemValidator from './validators/item';
import { SubstanceThcUsageModel } from './types';

const substanceThcUsageValidator: ValidateJSModel<SubstanceThcUsageModel> = {
  UsedThc: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedThc && attributes?.UsedThc.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: substanceDrugsUsageItemValidator,
        },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceThcUsageValidator;
